import { render } from "./SubContentContainer.vue?vue&type=template&id=5968ba06&scoped=true"
import script from "./SubContentContainer.vue?vue&type=script&lang=js"
export * from "./SubContentContainer.vue?vue&type=script&lang=js"

import "./SubContentContainer.vue?vue&type=style&index=0&id=5968ba06&scoped=true&lang=css"

import exportComponent from "E:\\workspace\\digital-gate\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5968ba06"]])

export default __exports__